import { render } from "./ConfirmAddressPage.vue?vue&type=template&id=b66c7eb8"
import script from "./ConfirmAddressPage.vue?vue&type=script&lang=js"
export * from "./ConfirmAddressPage.vue?vue&type=script&lang=js"

import "./ConfirmAddressPage.vue?vue&type=style&index=0&id=b66c7eb8&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__